import { StreamStateView_AbstractContent } from './streamStateView_AbstractContent';
import { check } from '@towns-protocol/dlog';
import { logNever } from './check';
import { streamIdFromBytes } from './id';
import { StreamStateView_ChannelMessages } from './streamStateView_Common_ChannelMessages';
export class StreamStateView_Channel extends StreamStateView_AbstractContent {
    streamId;
    spaceId = '';
    readonlytips = {};
    reachedRenderableContent = false;
    messages;
    constructor(streamId) {
        super();
        this.streamId = streamId;
        this.messages = new StreamStateView_ChannelMessages(streamId, this);
    }
    getStreamParentId() {
        return this.spaceId;
    }
    needsScrollback() {
        return !this.reachedRenderableContent;
    }
    applySnapshot(snapshot, content, _cleartexts, _encryptionEmitter) {
        this.spaceId = streamIdFromBytes(content.inception?.spaceId ?? Uint8Array.from([]));
    }
    prependEvent(event, cleartext, encryptionEmitter, _stateEmitter) {
        check(event.remoteEvent.event.payload.case === 'channelPayload');
        const payload = event.remoteEvent.event.payload.value;
        switch (payload.content.case) {
            case 'inception':
                break;
            case 'message':
                // if we have a refEventId it means we're a reaction or thread message
                if (!payload.content.value.refEventId) {
                    this.reachedRenderableContent = true;
                }
                this.messages.prependChannelMessage(event, cleartext, encryptionEmitter, undefined, payload.content.value);
                break;
            case 'redaction':
                break;
            case undefined:
                break;
            default:
                logNever(payload.content);
        }
    }
    appendEvent(event, cleartext, encryptionEmitter, _stateEmitter) {
        check(event.remoteEvent.event.payload.case === 'channelPayload');
        const payload = event.remoteEvent.event.payload.value;
        switch (payload.content.case) {
            case 'inception':
                break;
            case 'message':
                if (!payload.content.value.refEventId) {
                    this.reachedRenderableContent = true;
                }
                this.messages.appendChannelMessage(event, cleartext, encryptionEmitter, undefined, payload.content.value);
                break;
            case 'redaction':
                break;
            case undefined:
                break;
            default:
                logNever(payload.content);
        }
    }
    onDecryptedContent(eventId, content, emitter) {
        if (content.kind === 'channelMessage') {
            this.messages.onDecryptedContent(eventId, content, emitter);
        }
    }
}
//# sourceMappingURL=streamStateView_Channel.js.map